import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient,
    private loading: LoadingService,
    private datePipe: DatePipe,
  ) { }


  get_all_customers() {
    return this.http.get(this.baseUrl + '/get_all_customers');
  }

  getCustomerById(customerId: any) {
    return this.http.get(this.baseUrl + '/getCustomerById/' + customerId);
  }

  update_customer_status(customerId, status) {
    return this.http.get(this.baseUrl + '/update_customer_status/' + customerId + '/' + status);
  }



}
